export const POS_REFUND_LOOKING = "POS_REFUND_LOOKING";
export const POS_REFUND_LOOKUP = "POS_REFUND_LOOKUP";
export const POS_REFUND_LOOKUP_CLEAR = "POS_REFUND_LOOKUP_CLEAR";
export const POS_REFUND_BUSY = "POS_REFUND_BUSY";
export const POS_REFUND_DONE = "POS_REFUND_DONE";
export const POS_REFUND_ERROR = "POS_REFUND_ERROR";
export const POS_REFUND_CLEAR_LAST = "POS_REFUND_CLEAR_LAST";
